module.exports = __webpack_public_path__ + "static/budget-summary-banner-f48f2a0d91b15408f4c5a3ad89a940e3.png";